import type { ComponentProps } from 'react';

import { cn } from '../lib/cn.ts';

/** Клавиша: «⌘», «K», «Esc». */
export function Kbd({ className, ...props }: ComponentProps<'kbd'>) {
  return (
    <kbd
      className={cn(
        'inline-flex h-5 min-w-5 items-center justify-center rounded-xs border-thick border-border px-1',
        'font-sans text-[0.6875rem] font-bold text-muted',
        className,
      )}
      {...props}
    />
  );
}

/** Сочетание клавиш: keys={['⌘', 'K']}. */
export function Shortcut({ keys, className }: { keys: readonly string[]; className?: string }) {
  return (
    <span className={cn('inline-flex items-center gap-0.5', className)}>
      {keys.map((key) => (
        <Kbd key={key}>{key}</Kbd>
      ))}
    </span>
  );
}
